import React from 'react';
import { Text, Stack, Divider, VerticalDivider, Breakpoint } from '@moda/om';
import { ContactForm } from './ContactForm';

import './ContactUs.scss';

function isDST() {
  const now = new Date();
  const JANUARY = 0;
  const JULY = 6;
  const jan1 = new Date(now.getFullYear(), JANUARY, 1).getTimezoneOffset();
  const jul1 = new Date(now.getFullYear(), JULY, 1).getTimezoneOffset();
  return Math.max(jan1, jul1) !== now.getTimezoneOffset();
}

export const ContactUs: React.FC = () => {
  return (
    <>
      <Breakpoint gt="sm">
        <Stack className="ContactUs" space={7} direction="horizontal">
          <Stack space={5}>
            <Stack className="ContactUs__info" space={2}>
              <Text treatment="bold1">NEED ASSISTANCE?</Text>
              <Text treatment="body1">
                We are happy to help! Fill out the form below and our customer care team will be in
                touch as soon as possible.
              </Text>
            </Stack>
            <ContactForm showOrderNumberInput />
          </Stack>
          <VerticalDivider />
          <Stack space={4}>
            <Stack
              space={4}
              data-testid="contact-us-call-customer-care"
              className="ContactUs__static"
            >
              <Text treatment="bold1">CUSTOMER CARE</Text>
              <div className="ContantUs__care-phone">
                <Text treatment="bold1">Call Us</Text>
                <Text data-testid="ContactUs__static-text">
                  <div className="ContactUs__text">1 800-707-9898 (U.S.)</div>
                  <div className="ContactUs__text">+1-212-729-0984 (International)</div>
                </Text>
              </div>
              <div className="ContantUs__care-time">
                <div className="ContactUs__text">MON-FRI: 9am to 6pm {isDST() ? 'EDT' : 'EST'}</div>
              </div>

              <Stack space={0} className="ContantUs__care-email">
                <Text treatment="bold1">Email</Text>
                <a className="ContactUs__link" href="mailto:care@modaoperandi.com">
                  CARE@MODAOPERANDI.COM
                </a>
              </Stack>
            </Stack>
            <Stack data-testid="contact-us-press" className="ContactUs__static" space={4}>
              <Stack space={2}>
                <Text treatment="bold1">PRESS</Text>
                <Text data-testid="ContactUs__static-text">
                  <div>
                    For all your media inquiries, please contact{' '}
                    <a className="ContactUs__link" href="mailto:press@modaoperandi.com">
                      PRESS@MODAOPERANDI.COM
                    </a>{' '}
                  </div>
                </Text>
              </Stack>
            </Stack>
            <Stack data-testid="contact-us-designer-brands" className="ContactUs__static" space={4}>
              <Stack space={2}>
                <Text treatment="bold1">DESIGNER / BRANDS</Text>
                <Text data-testid="ContactUs__static-text">
                  <div>
                    If you are interested in working with Moda Operandi, please contact{' '}
                    <a className="ContactUs__link" href="mailto:designers@modaoperandi.com">
                      DESIGNERS@MODAOPERANDI.COM
                    </a>{' '}
                  </div>
                </Text>
              </Stack>
            </Stack>
            <Stack data-testid="contact-us-security" className="ContactUs__static" space={4}>
              <Stack space={2}>
                <Text treatment="bold1">SECURITY</Text>
                <Text data-testid="ContactUs__static-text">
                  <div>
                    Do you need to report a security or fraud issue?{' '}
                    <a className="ContactUs__link" href="mailto:security@modaoperandi.com">
                      SECURITY@MODAOPERANDI.COM
                    </a>{' '}
                  </div>
                </Text>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Breakpoint>
      <Breakpoint lt="sm">
        <Stack className="ContactUs" space={5}>
          <div>
            <Stack
              data-testid="contact-us-customer-care-mobile"
              className="ContactUs__info"
              space={2}
            >
              <Text treatment="bold1">NEED ASSISTANCE?</Text>
              <Text treatment="body1">
                We are happy to help! Fill out the form below and our customer care team will be in
                touch as soon as possible.
              </Text>
            </Stack>
            <ContactForm showOrderNumberInput />
          </div>
          <Divider />
          <Stack
            space={4}
            data-testid="contact-us-call-customer-care-mobile"
            className="ContactUs__static"
          >
            <Text treatment="bold1">CUSTOMER CARE</Text>
            <div className="ContantUs__care-phone">
              <Text treatment="bold1">Call Us</Text>
              <Text data-testid="ContactUs__static-text">
                <div className="ContactUs__text">1 800-707-9898 (U.S.)</div>
                <div className="ContactUs__text">+1-212-729-0984 (International)</div>
              </Text>
            </div>
            <div className="ContantUs__care-time">
              <div className="ContactUs__text">MON-FRI: 9am to 6pm {isDST() ? 'EDT' : 'EST'}</div>
            </div>

            <Stack space={0} className="ContantUs__care-email">
              <Text treatment="bold1">Email</Text>
              <a className="ContactUs__link" href="mailto:care@modaoperandi.com">
                CARE@MODAOPERANDI.COM
              </a>
            </Stack>
          </Stack>
          <Divider />
          <Stack
            data-testid="contact-us-press-mobile"
            className="ContactUs__static"
            space={0}
            direction="horizontal"
          >
            <Stack space={2}>
              <Text treatment="bold1">PRESS</Text>
              <Text data-testid="ContactUs__static-text">
                <div>
                  For all your media inquiries, please contact{' '}
                  <a className="ContactUs__link" href="mailto:press@modaoperandi.com">
                    PRESS@MODAOPERANDI.COM
                  </a>{' '}
                </div>
              </Text>
            </Stack>
          </Stack>
          <Stack
            data-testid="contact-us-designer-brands-mobile"
            className="ContactUs__static"
            space={0}
            direction="horizontal"
          >
            <Stack space={2}>
              <Text treatment="bold1">DESIGNER / BRANDS</Text>
              <Text data-testid="ContactUs__static-text">
                <div>
                  For all your media inquiries, please contact{' '}
                  <a className="ContactUs__link" href="mailto:designers@modaoperandi.com">
                    DESIGNERS@MODAOPERANDI.COM
                  </a>{' '}
                </div>
              </Text>
            </Stack>
          </Stack>
          <Stack
            data-testid="contact-us-security-mobile"
            className="ContactUs__static"
            space={0}
            direction="horizontal"
          >
            <Stack space={2}>
              <Text treatment="bold1">SECURITY</Text>
              <Text data-testid="ContactUs__static-text">
                <div>
                  Do you need to report a security or fraud issue?{' '}
                  <a className="ContactUs__link" href="mailto:security@modaoperandi.com">
                    SECURITY@MODAOPERANDI.COM
                  </a>{' '}
                </div>
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </Breakpoint>
    </>
  );
};
